import React from 'react'
import { connect } from 'react-redux'
import Login from '../Login'
import css from './styles.scss'

const Unauthorized = ({ app, hideLogin }) => {
  let buttonComponent = null

  if (!hideLogin) {
    buttonComponent = <Login />
  }

  return (
    <div className={`${css.container} ${app.standAloneMode ? css.containerStandAlone : ''}`}>
      <div className={css.attention}>!</div>
      <h4>You are not authorized to view the requested page.</h4>
      <p>
        Check your account permissions and access settings if you think this message is a mistake.
      </p>
      {buttonComponent}
    </div>
  )
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(Unauthorized)



// WEBPACK FOOTER //
// /app/js/components/Unauthorized/index.js